import { NoDataIcon } from "../../resources/icons/icons";
import Button from "../form-control/Button";

interface INotFoundComponent {
    text: string;
    onButtonClick?: () => void;
    actionButtonLabel?: string;
}

export default function NoDataFound(props: INotFoundComponent) {
    return (
        <div className="h-full flex flex-col items-center justify-center">
            <div className='bg-gray-100 dark:bg-slate-500 w-[70px] h-[70px] rounded-[50%] flex items-center justify-center p-2'>
                <NoDataIcon size={40} />
            </div>

            <h1 className="text-md md:text-2xl font-bold">{props.text}</h1>

            {props.onButtonClick && (
                <Button
                    label={props.actionButtonLabel ?? "Add data"}
                    className="bg-secondary-main hover:text-white rounded"
                    onClick={() => props.onButtonClick?.()}
                />
            )}
        </div>
    );
}